import React, { useContext, useState } from "react";
import { css } from "emotion";
import PlanCard from './PlanCard';
import plans from './data/plans';
import {GlobalContext} from "../../context/GlobalState";

const PlanCards = () => {
  const {currentWorkspace} = useContext(GlobalContext);
  let currentPlan = plans.filter(plan => plan.id === currentWorkspace.currentPlan);
  currentPlan = currentPlan.length > 0 ? currentPlan[0] : null;

  return (
    <div className={container}>
      { plans.map((plan) => <PlanCard key={plan.id} name={plan.name} mostPopular={plan.mostPopular} id={plan.id} currentPlan={currentPlan} price={plan.price} features={plan.features} />)}
    </div>
  );
};

export default PlanCards;

const container = css`
  padding: 12px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;
